import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const getProducts = () => api.get("/products").then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const submitOrder = (data) => api.post("/orders", data).then((r) => r.data);
export const submitQuote = (data) => api.post("/quotes", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const getSubmissions = (key) =>
  api.get("/admin/submissions", { headers: { "X-Admin-Key": key } }).then((r) => r.data);

export default api;
